"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Processing = require("./Processing");
Object.keys(_Processing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Processing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Processing[key];
    }
  });
});